import React from 'react';
import PackageCard from '../components/PackageCard';
import BeforeYouBook from '../components/BeforeYouBook';
import { Helmet } from 'react-helmet-async';
const StandardLessonsPage = () => {
  const standardPackages = [{
    title: '2 Hour Package',
    price: '£76',
    originalPrice: '£80',
    description: '£38 per hour - Automatic lessons for beginners or refresher sessions.',
    features: ['Save £4 on standard pricing', 'Behind-the-wheel training', 'Traffic rules and regulations', 'Flexible scheduling'],
    saving: '£4',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '6 Hour Package',
    price: '£225',
    originalPrice: '£240',
    description: '£37.50 per hour - Build your confidence and skills with multiple sessions.',
    features: ['Save £15 on standard pricing', 'Comprehensive driving practice', 'Manoeuvre training', 'Urban and suburban driving'],
    saving: '£15',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '10 Hour Package',
    price: '£370',
    originalPrice: '£400',
    description: '£37 per hour - Popular standard package for automatic lessons.',
    features: ['Save £30 on standard pricing', 'Complete driving skills coverage', 'Junction and roundabout mastery', 'Test preparation guidance'],
    popular: true,
    saving: '£30',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: '20 Hour Package',
    price: '£710',
    originalPrice: '£800',
    description: '£35.50 per hour - Comprehensive training for complete beginners.',
    features: ['Save £90 on standard pricing', 'Full driving curriculum', 'Advanced manoeuvres', 'Night driving practice'],
    saving: '£90',
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }, {
    title: 'Driving Test Booking',
    price: '£110',
    description: 'For NDS customers only - Includes DVSA test fee (£62).',
    features: ['Administrative handling of test booking', 'Securing available test dates', 'Email confirmation of booking', 'DVSA test fee (£62) included'],
    link: 'https://www.totaldrive.app/a/enquiry_form.php?17584722727972'
  }];
  return <div className="bg-white" data-id="element-1789">
      <Helmet data-id="element-1790">
        <title data-id="element-1791">Automatic Driving Lessons & Intensive Courses Northampton</title>
        <meta name="description" content="Learn at your own pace with flexible packages, or intensive driving courses in Northampton. Our 10-hour package is most popular with students." data-id="element-1792" />
        <meta name="keywords" content="automatic driving lessons Northampton, driving packages Northampton, block booking driving lessons, 10-hour driving lessons Northampton, automatic driving course deals Northampton, popular driving lesson packages Northampton" data-id="element-1793" />
      </Helmet>
      <div className="container mx-auto px-4 py-12" data-id="element-1794">
        <h1 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1795">
          Standard Driving Lessons
        </h1>
        <h2 className="sr-only" data-id="element-1796">10-Hour Driving Lessons Northampton</h2>
        <h2 className="sr-only" data-id="element-1797">Block Booking Discounts for Driving Lessons</h2>
        <h2 className="sr-only" data-id="element-1798">
          Automatic Driving Lesson Packages Northampton
        </h2>
        <div className="mb-8" data-id="element-1799">
          <p className="text-gray-700" data-id="element-1800">
            Our standard driving lessons are designed to fit around your
            schedule, allowing you to learn at your own pace. All lessons are
            conducted in automatic cars by qualified instructors who will tailor
            their teaching to your individual needs. Our 10-hour package is the
            most popular choice among our students.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1801">
          {standardPackages.map((pkg, index) => <PackageCard key={index} {...pkg} data-id="element-1802" />)}
        </div>
        <div className="bg-gray-50 rounded-lg p-8 mb-12" data-id="element-1803">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1804">
            What's Included in Our Standard Lessons?
          </h2>
          <ul className="space-y-4" data-id="element-1805">
            <li className="flex" data-id="element-1806">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1807">
                ✓
              </div>
              <div data-id="element-1808">
                <strong data-id="element-1809">Personalised Instruction</strong> - Lessons tailored to
                your learning style and experience level.
              </div>
            </li>
            <li className="flex" data-id="element-1810">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1811">
                ✓
              </div>
              <div data-id="element-1812">
                <strong data-id="element-1813">Automatic Vehicles</strong> - Modern, dual-controlled
                automatic cars that are easy to learn in.
              </div>
            </li>
            <li className="flex" data-id="element-1814">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1815">
                ✓
              </div>
              <div data-id="element-1816">
                <strong data-id="element-1817">Comprehensive Coverage</strong> - All aspects of
                driving, from basics to advanced manoeuvres.
              </div>
            </li>
            <li className="flex" data-id="element-1818">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1819">
                ✓
              </div>
              <div data-id="element-1820">
                <strong data-id="element-1821">Flexible Scheduling</strong> - Lessons available
                weekdays, evenings, and weekends.
              </div>
            </li>
            <li className="flex" data-id="element-1822">
              <div className="mr-4 text-burgundy-600" aria-hidden="true" data-id="element-1823">
                ✓
              </div>
              <div data-id="element-1824">
                <strong data-id="element-1825">Progress Tracking</strong> - Regular feedback and
                progress updates.
              </div>
            </li>
          </ul>
        </div>
        <div className="text-center" data-id="element-1826">
          <h2 className="text-2xl font-bold mb-4" data-id="element-1827">Ready to Get Started?</h2>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-1828">
            Start your journey with our affordable automatic driving lessons in
            Northampton — flexible hourly and package options available.
          </p>
          <div className="max-w-3xl mx-auto mb-8" data-id="element-1829">
            <BeforeYouBook data-id="element-1830" />
          </div>
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton" data-id="element-1831">
            Book Now
          </a>
        </div>
      </div>
    </div>;
};
export default StandardLessonsPage;